module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.2915/img/business-types/art-entertainment.png"